export default __webpack_public_path__ + "static/media/KatieCooper.a6fab975.jpeg";